import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { LabelColumnV2, } from "../../components/DataGridV2/DataColumnsV2";
import { Badge, IconButton, StyledEngineProvider, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { NumberLinearProgress } from "./SurveyMoments";
import ResponsiblePersonLabel from "./components/ResponsiblePersonLabel";
import { Block, CheckCircle, ErrorOutline, Message, PriorityHigh, Schedule } from "@mui/icons-material";
import clsx from "clsx";

export const getSurveyMomentColumns = ({
  t,
  keyPrefix,
  i18n,
  apiRef,
  theme,
  classes,
  objectModalListHandler,
  responsiblePersonOptions,
  relationNameOptions
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.SURVEY_MOMENTS_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.SURVEY_MOMENTS_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    mode: "client",
    getValueForFilter: (rowData, extraData) => {
      let value = ""
      switch (extraData.fieldName) {
        case "repairRequestCount":
          value = rowData.repairRequestCount.toString()
          break;
           case "number":
          value = rowData.number.toString()
          break;
        default:
          value = rowData[extraData.fieldName]
          break;
        
      }
      return value
    },
    getValueForCopy: (rowData, extraData) => {
      let value = ""
      switch (extraData.fieldName) {
        case "internalStatusPlainText":
          value = rowData.internalStatusPlainText
            ? t(rowData.internalStatusPlainText)
            : "";
          break;
        default:
          value = rowData?.[extraData?.fieldName]
          break;
      }
      return value
    }
  })

  return [
    {
      field: "extraInformation",
      headerName: " ",
      flex: 1,
      minWidth: 170,
      sortable: true,
      download:false,
      renderHeader: () => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            overflow: "visible",
          }}
        >
          <div className={classes.iconContainer}>
            <PriorityHigh color="secondary" className={classes.icon} />
          </div>
          <div className={classes.iconContainer}>
            <ErrorOutline fontSize="small" color="error" />
          </div>
          <div className={classes.iconContainer}>
            <Schedule fontSize="small" className={clsx(classes.pending, "pending")} />
          </div>
          <div className={classes.iconContainer}>
            <Message className={classes.tableIcon} />
          </div>
        </div>
      ),
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";

        const {
          is48hoursReminder,
          hasUpdate,
          overdue,
          messageCount,
          wbStatus,
          buildingId,
          objectId,
          isBlocked,
          isBuildingMapped,
        } = rowData;

        return (
          <LabelColumnV2
            label={
              <Typography
                noWrap
                sx={{
                  display: "flex",
                  alignItems: "center",
                  overflow: "visible",
                }}
              >
                <div className={classes.iconContainer}>
                  {hasUpdate && (
                    <Tooltip title={t("general.actionRequired")}>
                      <PriorityHigh color="secondary" className={classes.icon} />
                    </Tooltip>
                  )}
                </div>
                <div className={classes.iconContainer}>
                  {objectId && !isBuildingMapped && (
                    <Tooltip title={t("wkb.objectIsNotLinked")}>
                      <IconButton
                        className={classes.iconButton}
                        onClick={(e) =>
                          objectModalListHandler(e, buildingId, objectId)
                        }
                        size="large"
                      >
                        <ErrorOutline className={classes.colorWarning} />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
                <div className={classes.iconContainer}>
                  {(is48hoursReminder || overdue || wbStatus || isBlocked) && (
                    <Tooltip
                      title={t(
                        wbStatus
                          ? "wkb.surveyingMoment.internalStatus.2"
                          : isBlocked
                            ? "survey.blocked"
                            : "general.overdue"
                      )}
                    >
                      {wbStatus ? (
                        <CheckCircle
                          fontSize="small"
                          className={classes.colorSuccess}
                        />
                      ) : isBlocked ? (
                        <Block fontSize="small" color="error" />
                      ) : (
                        <Schedule
                          fontSize="small"
                          color="error"
                          className={clsx(
                            is48hoursReminder && classes.warning,
                            overdue && classes.pending,
                            classes.icon
                          )}
                        />
                      )}
                    </Tooltip>
                  )}
                </div>
                <div className={classes.iconContainer}>
                  <Tooltip title={t("layout.navbar.messages")}>
                    <Badge
                      badgeContent={messageCount}
                      color="secondary"
                      className={classes.messageCountIcon}
                    >
                      <Message className={classes.tableIcon} />
                    </Badge>
                  </Tooltip>
                </div>
              </Typography>
            }

          />

        );
      },
    },
    {
      download: true,
      print: true,
      field: "number",
      headerName: t("general.id"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.number}
            cellSubMenuOptions={{ options: getOptions({ field: "number", isQuickFilterDisplay:Boolean( rowData?.number.toString()) }), extraData: { fieldName: "number" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "object",
      headerName: t("general.object"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.object}
            cellSubMenuOptions={{ options: getOptions({ field: "object", isQuickFilterDisplay: Boolean(rowData.object) }), extraData: { fieldName: "object" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "name",
      headerName: t("wkb.surveyingMoment"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.name}
            cellSubMenuOptions={{ options: getOptions({ field: "name", isQuickFilterDisplay: Boolean(rowData.name) }), extraData: { fieldName: "name" } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "handlingPeriod",
      headerName: t('wkb.surveyingMoment.handelingPeriod'),
      flex: 1,
      minWidth: 90,
      filterable: false,
      download: true,
      renderCell: (params) => {
      const rowData = params.row;
        return <LabelColumnV2
          label={rowData.handlingPeriod}
          tooltipLabel={rowData.handlingPeriod}
          cellSubMenuOptions={{ options: getOptions({sortable: false,filterable : false, field: "handlingPeriod", isQuickFilterDisplay: false }), extraData: { fieldName: "handlingPeriod",  } }}
          request={rowData}
        />
      },
    },
    {
      download: true,
      print: true,
      field: "assignments",
      headerName: t("wkb.assignments.label"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.assignments}
            cellSubMenuOptions={{ options: getOptions({ field: "assignments", isQuickFilterDisplay: Boolean(rowData.assignments) }), extraData: { fieldName: "assignments" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "repairRequestCount",
      headerName: t("general.repairRequests"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.repairRequestCount}
            cellSubMenuOptions={{ options: getOptions({ field: "repairRequestCount", isQuickFilterDisplay: Boolean(rowData.repairRequestCount.toString()) }), extraData: { fieldName: "repairRequestCount" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "relationNameId",
      headerName: t("wkb.executive"),
      type: "singleSelect",
      valueOptions: relationNameOptions,
      flex: 1,
      minWidth: 190,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        const person = rowData.responsiblePerson;
        return (
          <ResponsiblePersonLabel
            label={rowData?.responsiblePerson?.relationName || ""}
            person={person}
             request={rowData}
            cellSubMenuOptions={{ options: getOptions({ field: "relationNameId", isQuickFilterDisplay: Boolean(rowData?.relationNameId) }), extraData: { fieldName: 'relationNameId', type: 'singleSelect' } }}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "responsiblePersonId",
      headerName: t("general.company"),
      flex: 1,
      minWidth: 90,
      type: "singleSelect",
      valueOptions: responsiblePersonOptions,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData.responsiblePerson) return "";
        return (
          <LabelColumnV2
            label={rowData.responsiblePersonName}
            cellSubMenuOptions={{ options: getOptions({ field: "responsiblePersonId", isQuickFilterDisplay: Boolean(rowData.responsiblePersonId) }), extraData: { fieldName: "responsiblePersonId", type: 'singleSelect' } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "internalStatusPlainText",
      headerName: t("wkb.surveyingMoment.internalStatus"),
      type: 'singleSelect',
      valueOptions: [0, 1, 2, 3].map((val) => ({
        value: "wkb.surveyingMoment.internalStatus."+ val,
        label: t(`wkb.surveyingMoment.internalStatus.${val}`),
      })),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={t(rowData.internalStatusPlainText)}
            cellSubMenuOptions={{ options: getOptions({ field: "internalStatusPlainText", isQuickFilterDisplay: Boolean(rowData?.internalStatusPlainText) }), extraData: { fieldName: "internalStatusPlainText", type: 'singleSelect' } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "progress",
      headerName: t("wkb.surveyingMoment.progress"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        const { totalAssignments, completedAssignments } = rowData;
        return (
          <LabelColumnV2
            label={
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                  {
                    <NumberLinearProgress
                      value={(
                        (completedAssignments / totalAssignments) *
                        100
                      ).toFixed(2)}
                    />
                  }
                </ThemeProvider>
              </StyledEngineProvider>
            }
          />
        );
      },
    },
  ];
}

